import Tags from "./Tags";
import { AlertTriangle, CheckCircle, Circle, Clock3, Loader, Mail, Send, XCircle } from "./icons";

/*
  StatusTag Component

  One look for a request's normalized DISPLAY status everywhere (lists,
  details, cards). Colour is never the only signal: every status has its own
  icon and text. The label comes from the API (`status.label`), the original
  status stays available as the tooltip.

  status   { display, native, label:{ar,en} }  (the unified requests API shape)
  lang     "ar" | "en"
  size     sm / md
*/

const LOOK = {
  pending: { variant: "warning", icon: Clock3 },
  inProgress: { variant: "info", icon: Loader },
  awaitingAction: { variant: "warning", icon: AlertTriangle },
  awaitingReview: { variant: "primary", icon: Clock3 },
  active: { variant: "success", icon: Circle },
  approved: { variant: "success", icon: CheckCircle },
  sent: { variant: "info", icon: Send },
  failed: { variant: "danger", icon: Mail },
  completed: { variant: "success", icon: CheckCircle },
  rejected: { variant: "danger", icon: XCircle },
  canceled: { variant: "neutral", icon: XCircle },
  deleted: { variant: "neutral", icon: XCircle },
  unknown: { variant: "neutral", icon: Circle },
};

const StatusTag = ({ status, lang = "en", size = "sm", className = "" }) => {
  const display = status?.display && LOOK[status.display] ? status.display : "unknown";
  const { variant, icon: Icon } = LOOK[display];
  const label = status?.label?.[lang === "ar" ? "ar" : "en"] || status?.native || "—";
  return (
    <Tags
      variant={variant}
      appearance="soft"
      size={size}
      icon={<Icon size={13} aria-hidden="true" />}
      title={status?.native || undefined}
      className={`ui-status-tag is-${display} ${className}`}
    >
      {label}
    </Tags>
  );
};

export default StatusTag;
